module.exports = __webpack_public_path__ + "static/media/upcoming-active.bc3197a4.svg";